import { Translation } from '../Translation'
import merge from 'deepmerge'
import { fr_common } from '@valuecase/ui-components'

// Deepmerge - merge with nothing, all seller translations are in common package
const override = {}
const fr: Translation = merge(fr_common, override)
export default fr
